module.exports = __webpack_public_path__ + "img/bgjykxyjy-logo.5f445b37.png";